import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

 useEffect(() => {
         const observer = new IntersectionObserver(
             ([entry]) => {
                 setIsHeroNavVisible(entry.isIntersecting);
                 const navbar = document.querySelector(".navbar.alt");
                 if (navbar) {
                     if (!entry.isIntersecting) {
                         navbar.style.marginTop = "0px";
                     } else {
                         navbar.style.marginTop = "-100px";
                     }
                 }
             },
             { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (

    <div className="App">
<ResponsiveAppBarAlt />

<main>

  <Box className="heroWrapper subpage" id="start">

  <img src="Familie.webp" className='herobackimg' />
    <Box className='heroWrapperLayer'></Box>
    <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

    </Container>

    <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
      <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
      <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
      <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
      <HashLink className='navItemHero' smooth to="/Blog">Blog</HashLink>
      <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
      <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
    </Box>

    {/* <div className="heroCTAWrapper">
      <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
    </div> */}
  </Box>


  <Box className="mainWrapper">

    <Container maxWidth="lg" className="subPageContainerThin">


      <HashLink className='breadcrumb' smooth to="/#leistungen">Leistungen</HashLink>
      <Typography variant='h1' className='subTitle'>Familie</Typography>


      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Heiraten</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
        Wer heiratet, geht mehrere rechtliche Verpflichtungen gegenüber dem anderen Ehegatten ein. Sollten sich die Ehegatten scheiden lassen, muss der besser verdiende Ehegatte dem anderen Ehegatten ggf. einen Geldausgleich zahlen, den sog. Zugewinnausgleich. Darüber hinaus müssen die Ehegatten Rentenanwartschaften neu aufteilen. Unter bestimmten Voraussetzungen muss ein Ehegatte auch nach der Scheidung Unterhalt leisten. Die gesetzlich vorgesehenen Verpflichtungen können der Situation der Eheleute nicht immer gerecht werden. Daher sollten junge Ehegatten sich von einem Notar zu den rechtlichen Folgen einer Eheschließung beraten lassen. Je nach Bedarf kann der Notar größere oder kleinere Modifikationen für den Ausgleich im Falle einer Scheidung vorsehen – seien diese ein Ausschluss oder eine Einschränkung der genannten Regelungen oder auch eine Erweiterung der Rechte – etwa zugunsten des ein Kind erziehenden Elternteils. Dadurch vermeiden die Ehegatten die Gefahr eines teuren und emotional extrem belastenden Rosenkriegs. Einen Ehevetrag können sie bereits vor der Eheschließung im Standesamt und auch jederzeit danach abschließen. 
            </Typography>
            {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Ehevertrag Formular</HashLink></Button> */}
            <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Scheidung</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
  Wollen sich Ehegatten scheiden lassen, stellen sich zahlreiche rechtliche Fragen. Derjenige Ehegatte, der im Verlauf der Ehe mehr Vermögen hinzuerworben hat, muss dem anderen Ehegatten einen sog. Zugewinnausgleich zahlen. Außerdem muss jeder Ehegatte dem anderen Ehegatten die Hälfte seiner Rentenanwartschaften abgeben, die er während der Ehezeit erworben hat. Unter bestimmten Voraussetzungen muss ein Ehegatte dem anderen Ehegatten auch nach der Scheidung Unterhalt leisten. Dies gilt insbesondere dann, wenn ein Ehegatte sich um die Erziehung minderjähriger Kinder kümmert. Häufig wollen Ehegatten von diesen gesetzlichen Regeln durch Abschluss einer sog. Scheidungsfolgenvereinbarung abweichen. Haben sie zudem gemeinsam eine Immobilie angeschafft, wollen sie das Eigentum meist auf einen Ehegatten allein übertragen. All diese Vorgänge können die Eheleute bei einem Notar regeln.
  </Typography>
  {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Scheidungsfolgenvereinbarung Formular</HashLink></Button> */}
  <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Adoption</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
  Wer eine andere Person adoptieren will, muss dafür dem Familiengericht mehrere Erklärungen vorlegen, die vor einem Notar angegeben wurden. Der Notar berät die Beteiligten über die rechtlichen Folgen der Adoption und reicht die Erklärungen bei dem Familiengericht ein. 
  </Typography>
  {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Adoption Formular</HashLink></Button> */}
  <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>


    </Container>

                     <Box className="map" id="map">
                                                     <Box className="contactMap">
                     
                                                         {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}
                     
                                                         <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank" class="contactMapLink">
                                                             <img src="Karte-HT.webp" className="contactMapImg" />
                                                             <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
                                                         </a>
                                                         <Container maxWidth="lg" className="container">
                                                             <Typography variant='body1' paragraph className="contactMapAddress">
                                                                 Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                                                             </Typography>
                                                         </Container>
                                                         
                                                     </Box>
                                                     {/* <Container maxWidth="lg" id="routelink">
                                                         <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank">hier</a>.</Typography>
                                                     </Container> */}
                     
                                                 </Box>



                      <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. Im Parkzentrum Holzgasse (Scheerengasse 5, 53721 Siegburg) können Sie die mit „HT Notare“ markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Tiefgarage rechts abbiegen und dann in dieser Richtung bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie durch eine eigene Tür mit Klingelschild in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>

  </Box>

</main >
<Footer />
    </div >
  );
};

export default ScrollAnimation;